import { AFFILIATE_URL, AFF_DISCLOSURE } from "../../lib/constants";
import { trackCta } from "../../lib/tracking";

export const BottomCTA = () => (
  <section className="bg-[#0F172A] py-20" data-testid="bottom-cta-banner">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-white">
        Ready to create AI voices that actually sound human?
      </h2>
      <p className="mt-4 text-lg text-slate-300 leading-relaxed">
        ElevenLabs is free to try — no credit card needed. Join over a million creators and developers already using it.
      </p>
      <a
        href={AFFILIATE_URL}
        target="_blank"
        rel="nofollow sponsored noopener"
        onClick={() => trackCta("bottom-banner", AFFILIATE_URL)}
        data-testid="cta-bottom-banner"
        className="mt-8 inline-block bg-[#5A31F4] text-white hover:bg-[#4B29CD] rounded-md px-10 py-5 font-bold text-lg transition-all duration-200 shadow-lg hover:-translate-y-1"
      >
        Get Started Free with ElevenLabs →
      </a>
      <p className="mt-4 text-sm text-slate-400">Free plan available • 29 languages • Voice cloning included</p>
      <p className="mt-3 text-xs text-slate-500 max-w-md mx-auto" data-testid="bottom-affiliate-disclosure">{AFF_DISCLOSURE}</p>
    </div>
  </section>
);
